import { render, staticRenderFns } from "./downapp.vue?vue&type=template&id=41196097&scoped=true&"
import script from "./downapp.vue?vue&type=script&lang=js&"
export * from "./downapp.vue?vue&type=script&lang=js&"
import style1 from "./downapp.vue?vue&type=style&index=1&id=41196097&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41196097",
  null
  
)

export default component.exports